import { defineMessages } from 'react-intl';

// Home Scope
const homeScope = 't.page.home';

// Transaction Scope
const transactionsScope = 't.page.transactions';

// Global Scope
const globalScope = 't.global';

export default defineMessages({
	// Home Scope
	dashboardUpdate: {
		id: `${homeScope}.period.dashboardUpdate`,
		defaultMessage: 'Dashboard aggiornata alle: ',
	},
	period: {
		id: `${homeScope}.period.definedPeriod`,
		defaultMessage: 'Periodo Considerato',
	},
	from: {
		id: `${homeScope}.period.from`,
		defaultMessage: 'Da: ',
	},
	to: {
		id: `${homeScope}.period.to`,
		defaultMessage: 'A: ',
	},
	definedPeriod2: {
		id: `${homeScope}.period.definedPeriod2`,
		defaultMessage: 'Periodo Considerato: ',
	},
	lastDay: {
		id: `${homeScope}.period.lastDay`,
		defaultMessage: 'Ultimo Giorno',
	},
	day: {
		id: `${homeScope}.period.day`,
		defaultMessage: 'DAY',
	},
	lastWeek: {
		id: `${homeScope}.period.lastWeek`,
		defaultMessage: 'Ultima Settimana',
	},
	week: {
		id: `${homeScope}.period.week`,
		defaultMessage: 'WEEK',
	},
	lastMonth: {
		id: `${homeScope}.period.lastMonth`,
		defaultMessage: 'Ultimo Mese',
	},
	month: {
		id: `${homeScope}.period.month`,
		defaultMessage: 'MONTH',
	},
	sales: {
		id: `${homeScope}.sales`,
		defaultMessage: 'Vendite',
	},
	transactionsState: {
		id: `${homeScope}.transactionsState`,
		defaultMessage: 'Stato transazioni di pagamento',
	},
	transactionsStateSub: {
    id: `${homeScope}.transactionsState.subtitle`,
    defaultMessage: 'Escluse le operazioni di Ricarica e Enrollment',
  },
	transactionsStateCreditCard: {
		id: `${homeScope}.transactionsStateCreditCard`,
		defaultMessage: 'Stato transazioni carta di credito',
	},
	seeTransactions: {
		id: `${homeScope}.seeTransactions`,
		defaultMessage: 'Vedi transazioni',
	},
	noTransactionData: {
		id: `${homeScope}.noTransactionData`,
		defaultMessage: 'Nessuna transazione trovata per la valuta selezionata.',
	},
	subtitle: {
		id: `${homeScope}.transactionsPopup.subtitle`,
		defaultMessage: 'Di seguito vengono riportate le ultime 10 transazioni.',
	},
	anchor: {
		id: `${homeScope}.transactionsPopup.anchor`,
		defaultMessage: "Vai all'elenco completo",
	},
	labelYaxis: {
    id: `${homeScope}.labelYaxis`,
    defaultMessage: 'Numero transazioni',
  },
  labelVolume: {
    id: `${homeScope}.labelVolume`,
    defaultMessage: 'Volume totale',
  },
	labelAmountIn: {
    id: `${homeScope}.labelAmountIn`,
    defaultMessage: 'Importo in',
  },

	// Transaction Scope
	transactionId: {
		id: `${transactionsScope}.transactionId`,
		defaultMessage: 'ID Transazione',
	},
	merchantId: {
		id: `${transactionsScope}.merchantId`,
		defaultMessage: 'Merchant',
	},
	merchantName: {
		id: `${transactionsScope}.merchantName`,
		defaultMessage: 'Merchant',
	},
	amount: {
		id: `${transactionsScope}.amount`,
		defaultMessage: 'Importo',
	},
	creationDate: {
		id: `${transactionsScope}.creationDate`,
		defaultMessage: 'Data',
	},
	transactionStatus: {
		id: `${transactionsScope}.transactionStatus`,
		defaultMessage: 'Stato',
	},
	paymentChannel: {
		id: `${transactionsScope}.paymentChannel`,
		defaultMessage: 'Canale di pagamento',
	},
	AUTHORIZED: {
		id: `${transactionsScope}.AUTHORIZED`,
		defaultMessage: 'Autorizzata',
	},
	AUTHORIZING: {
		id: `${transactionsScope}.AUTHORIZING`,
		defaultMessage: 'In autorizzazione',
	},
	REJECTED: {
		id: `${transactionsScope}.REJECTED`,
		defaultMessage: 'Rifiutata',
	},
	EXPIRED: {
		id: `${transactionsScope}.EXPIRED`,
		defaultMessage: 'Scaduta',
	},
	REVERSED: {
		id: `${transactionsScope}.REVERSED`,
		defaultMessage: 'Stornata',
	},
	CANCELLED: {
		id: `${transactionsScope}.CANCELLED`,
		defaultMessage: 'Cancellata',
	},
	ACCOUNTED: {
		id: `${transactionsScope}.ACCOUNTED`,
		defaultMessage: 'Contabilizzata',
	},
	CANCELED: {
		id: `${transactionsScope}.CANCELED`,
		defaultMessage: 'Cancellata',
	},
	TO_BE_REVERSED: {
		id: `${transactionsScope}.TO_BE_REVERSED`,
		defaultMessage: 'Da stornare',
	},
	TO_BE_AUTHORIZED: {
		id: `${transactionsScope}.TO_BE_AUTHORIZED`,
		defaultMessage: 'Da autorizzare',
	},
	NOT_REVERSED_FOR_ERRORS: {
		id: `${transactionsScope}.NOT_REVERSED_FOR_ERRORS`,
		defaultMessage: 'Non stornata per errori',
	},
	NOT_AUTHORIZED: {
		id: `${transactionsScope}.NOT_AUTHORIZED`,
		defaultMessage: 'Non autorizzata',
	},
	PARTIAL_REFUNDED: {
		id: `${transactionsScope}.PARTIAL_REFUNDED`,
		defaultMessage: 'Parzialmente rimborsata',
	},
	REFUNDED: {
		id: `${transactionsScope}.REFUNDED`,
		defaultMessage: 'Rimborsata',
	},

	// Global Scope
	currency: {
		id: `${globalScope}.currency`,
		defaultMessage: 'Valuta',
	},
});
